module.exports = __webpack_public_path__ + "static/img/platphom10.da372d5b.png";